// extracted by mini-css-extract-plugin
export default {"foRow":"Row_foRow__XcSK1"};